import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useFacilitiesApi() {
  const callApi = useApiCall();

  const getFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_LIST, data, onSuccess, onError);
  };
  const getFacilityDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_DETAILS, data, onSuccess, onError);
  };

  const saveFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_FACILITY, data, onSuccess, onError);
  };
  const deleteFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.DELETE_FACILITY, data, onSuccess, onError);
  };

  const getProcessingFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_PROCESSING_FACILITY_LIST, data, onSuccess, onError);
  };

  const getFacilityCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_CODE, data, onSuccess, onError);
  };

  const getSubFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_LIST, data, onSuccess, onError);
  };

  const saveSubFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY, data, onSuccess, onError);
  };


  const getSubFacilityTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_TYPE_LIST, data, onSuccess, onError);
  };


  const SaveSubFacilityImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY_IMAGE, data, onSuccess, onError);
  };

  const SaveFacilityImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_FACILITY_IMAGE, data, onSuccess, onError);
  };

  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_TO_CSV, data, onSuccess, onError);
  }
  const Exportpdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_TO_PDF, data, onSuccess, onError);
  }
  const ExportQrCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_QR_CODE, data, onSuccess, onError);
  }
  


  return {
    getFacilityList,
    getFacilityDetails,
    saveFacility,
    deleteFacility,
    getProcessingFacilityList,
    getFacilityCode,
    getSubFacilityList,
    saveSubFacility,
    getSubFacilityTypeList,
    SaveSubFacilityImage,
    SaveFacilityImage,
    
    Exportcsv,
    Exportpdf,
    ExportQrCode,

  };
}
